import { render, staticRenderFns } from "./Correction.vue?vue&type=template&id=11f0e15a&scoped=true"
import script from "./Correction.vue?vue&type=script&lang=js"
export * from "./Correction.vue?vue&type=script&lang=js"
import style0 from "./Correction.vue?vue&type=style&index=0&id=11f0e15a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f0e15a",
  null
  
)

export default component.exports